/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCallback, useEffect, useState } from "react";
import { useShowError } from "~/components/Error/useShowError";
import { PDService } from "~/models/pagerDuty";
import { useAxios } from "~/tools";

const usePDServices = (customerId?: string) => {
  const [services, setServices] = useState<PDService[]>([]);
  const [servicesLoading, setServicesLoading] = useState(false);

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const fetchServices = useCallback(async () => {
    setServicesLoading(true);
    try {
      const { data } = await Axios().get(
        `/mcrp/pagerduty/customers/${customerId}/services`
      );
      setServices(data?.services);
    } catch (e) {
      showError(e.response);
    }
    setServicesLoading(false);
  }, [setServicesLoading, Axios, customerId, setServices, showError]);

  useEffect(() => {
    if (customerId) {
      fetchServices();
    }
  }, [customerId, fetchServices]);

  return { services, servicesLoading };
};

export { usePDServices };
